import { Navigate, Outlet } from 'react-router'

import { isOrgAdmin, useCurrentUser } from '../../../models/user'

export function AdminLayout() {
  const { user } = useCurrentUser({ enabled: true })

  if (user && !isOrgAdmin(user)) {
    return <Navigate to="/insure/insurance" />
  }

  return <Outlet />
}
